import * as _ from 'lodash';
import './messages/MeetingMessagesComponent.tsx';
import { MeetingMessage } from '../../objects/MeetingMessage';

angular.module("tromanWeb").controller('MeetingMessagesController', ['$q', 'stateService', 'tromanServer', 'ObjectCache', 'dialogService', 'meetingShared', function ($qservice, _stateService, tromanServer, ObjectCache, dialogService, meetingShared) {

    this.users = new Map();
    this.messages = void(0);

    this.onAdd = (addcmd) => {
        this.messages = void(0);
        return tromanServer.Meetings.addMessage(meetingShared.meeting.Id, addcmd)
            .then(() => { this._reload(); })
            .catch(dialogService.error);
    };

    this.onUpdate = (updatecmd) => {
        this.messages = void(0);
        return tromanServer.Meetings.updateMessage(meetingShared.meeting.Id, updatecmd)
            .then(() => { this._reload(); })
            .catch(dialogService.error);
    };

    this.onDelete = (messageId) => {
        this.messages = void(0);
        return tromanServer.Meetings.deleteMessage(meetingShared.meeting.Id, messageId)
            .then(() => { this._reload(); })
            .catch(dialogService.error);
    };

    const parseMessages = (result) => _.map(result, x => new MeetingMessage(x, this.users));

    this._reload = () => {
        return tromanServer.Meetings.getMessages(meetingShared.meeting.Id)
            .then(result => { this.messages = parseMessages(result); })
            .catch(dialogService.error);
    };

    this.$onInit = () => {
        $qservice
            .all({
                messages: tromanServer.Meetings.getMessages(meetingShared.meeting.Id),
                users: ObjectCache.getAllUsers(),
            })
            .then(result => {
                this.users = new Map(_.map(result.users, x => [x.Id, x]));
                this.messages = parseMessages(result.messages);
            })
            .catch(dialogService.error);
    };
}]);
